// eslint-disable-next-line
function dataStatisticsAdapter(postingStatistics) {
  if (!postingStatistics) return {};
  if (postingStatistics) {
    return {
      impressions: {
        total: postingStatistics.impression && postingStatistics.impression.total,
        percentage: postingStatistics.impression && postingStatistics.impression.percentage,
        status: postingStatistics.impression && postingStatistics.impression.status
      },
      visits: {
        total: postingStatistics.visit && postingStatistics.visit.total,
        percentage: postingStatistics.visit && postingStatistics.visit.percentage,
        status: postingStatistics.visit && postingStatistics.visit.status
      },
      leads: {
        total: postingStatistics['user-stat'] && postingStatistics['user-stat'].total,
        percentage: postingStatistics['user-stat'] && postingStatistics['user-stat'].percentage,
        status: postingStatistics['user-stat'] && postingStatistics['user-stat'].status,
        totalLeads: postingStatistics.leads && postingStatistics.leads.total,
        totalPercentage: postingStatistics.leads && postingStatistics.leads.percentage,
        totalStatus: postingStatistics.leads && postingStatistics.leads.status,
        anonymousLeads: postingStatistics['anonymous-stat'] && postingStatistics['anonymous-stat'].total,
        anonymousPercentage: postingStatistics['anonymous-stat'] && postingStatistics['anonymous-stat'].percentage,
        anonymousStatus: postingStatistics['anonymous-stat'] && postingStatistics['anonymous-stat'].status
      },
      userStats: {
        leadForm: postingStatistics.userStats && postingStatistics.userStats.leadForm,
        viewData: postingStatistics.userStats && postingStatistics.userStats.viewData,
        whatsapp: postingStatistics.userStats && postingStatistics.userStats.whatsapp,
        anonymous: postingStatistics.userStats && postingStatistics.userStats.totalAnonymous
      },
      impressionViews: {
        conversion: postingStatistics['impression-views-conversion']
      },
      viewsLeads: {
        conversion: postingStatistics['views-leads-conversion']
      }
    };
  }
}

export { dataStatisticsAdapter };
